'use client'

// React Imports
import { useEffect, useRef } from 'react'

// Next Imports

// MUI Imports
import Link from 'next/link'

import { styled, useColorScheme, useTheme } from '@mui/material/styles'

// Type Imports

import Divider from '@mui/material/Divider'

import type { Mode, SystemMode } from '@core/types'

// Component Imports
import VerticalNav, { NavHeader } from '@menu/vertical-menu'
import VerticalMenu from './VerticalMenu'
import NavCollapseIcons from '@menu/components/vertical-menu/NavCollapseIcons'

// Hook Imports
import { useSettings } from '@core/hooks/useSettings'
import useVerticalNav from '@menu/hooks/useVerticalNav'

// Style Imports
import navigationCustomStyles from '@core/styles/vertical/navigationCustomStyles'
import Logo from '@/components/Logo'

type Props = {
  mode: Mode
  systemMode: SystemMode
}

const StyledBoxForShadow = styled('div')(({ theme }) => ({
  top: 60,
  left: -8,
  zIndex: 2,
  opacity: 0,
  position: 'absolute',
  pointerEvents: 'none',
  width: 'calc(100% + 15px)',
  height: theme.mixins.toolbar.minHeight,
  transition: 'opacity .15s ease-in-out'

  // background: `linear-gradient(var(--mui-palette-background-default) ${
  //   theme.direction === 'rtl' ? '95%' : '5%'
  // }, rgb(var(--mui-palette-background-defaultChannel) / 0.85) 30%, rgb(var(--mui-palette-background-defaultChannel) / 0.5) 65%, rgb(var(--mui-palette-background-defaultChannel) / 0.3) 75%, transparent)`,
  // '&.scrolled': {
  //   opacity: 1
  // }
}))

const Navigation = (props: Props) => {
  // Props
  const { mode, systemMode } = props

  // Hooks
  const verticalNavOptions = useVerticalNav()
  const { settings } = useSettings()
  const { mode: muiMode, systemMode: muiSystemMode } = useColorScheme()
  const theme = useTheme()

  // Refs
  const shadowRef = useRef(null)

  // Vars
  const { isBreakpointReached, isCollapsed } = verticalNavOptions
  const { width, isToggled } = verticalNavOptions
  const isServer = typeof window === 'undefined'
  const isSemiDark = settings.semiDark
  let isDark

  if (isServer) {
    isDark = mode === 'system' ? systemMode === 'dark' : mode === 'dark'
  } else {
    isDark = muiMode === 'system' ? muiSystemMode === 'dark' : muiMode === 'dark'
  }

  const scrollMenu = (container: any, isPerfectScrollbar: boolean) => {
    container = isBreakpointReached || !isPerfectScrollbar ? container.target : container

    if (shadowRef && container.scrollTop > 0) {
      // @ts-ignore
      if (!shadowRef.current.classList.contains('scrolled')) {
        // @ts-ignore
        shadowRef.current.classList.add('scrolled')
      }
    } else {
      // @ts-ignore
      shadowRef.current.classList.remove('scrolled')
    }
  }

  useEffect(() => {
    // if (isBreakpointReached === undefined) return
    // if (settings.layout === 'collapsed' && !isBreakpointReached) {
    //   if (!isCollapsed) collapseVerticalNav(true)
    // } else {
    //   if (isCollapsed) collapseVerticalNav(false)
    // }
    // collapseVerticalNav(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings.layout, isBreakpointReached, isCollapsed])

  return (
    <>
      <VerticalNav
        breakpoint='always'
        customStyles={navigationCustomStyles(verticalNavOptions, theme)}
        collapsedWidth={0}
        backgroundColor='var(--mui-palette-primary-main)'
        {...(isSemiDark &&
          !isDark && {
            'data-mui-color-scheme': 'dark'
          })}
      >
        <NavHeader>
          <div className='flex-1 flex items-center justify-center'>
            <Link href='/'>
              <Logo size='large' />
            </Link>
          </div>
        </NavHeader>
        <Divider sx={{ borderWidth: '1px', marginBottom: '1rem', marginTop: '0.4rem', borderColor: '#fff' }} />

        <StyledBoxForShadow ref={shadowRef} />
        <VerticalMenu scrollMenu={scrollMenu} />
      </VerticalNav>

      {isBreakpointReached && isToggled && (
        <span
          style={{
            position: 'fixed',
            top: 10,
            left: (width ?? 260) - 4,
            transform: 'translateX(-50%)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 0,
            width: 36,
            height: 36,
            borderRadius: '50%',
            backgroundColor: '#fff',
            border: '1px solid var(--mui-palette-primary-main)',
            color: 'var(--mui-palette-primary-main)',
            cursor: 'pointer'
          }}
        >
          <NavCollapseIcons style={{ color: 'var(--mui-palette-primary-main)', fontSize: '1.35rem' }} />
        </span>
      )}
    </>
  )
}

export default Navigation
